import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Stack} from 'views/components';
import {SecureImageDisplay} from 'views/module/secureStorage/DisplayComponents';
import {Translate} from 'views/module';

const SlipexpenseDetails = (props) => {
  const {expenses} = props;
  return (
    <Stack spacing={2} sx={{px: 2, py: 1}}>
      {
        expenses.map((exp, idx) => (
          <Box
            key={idx}
            sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 3,
              bgcolor: 'background.paper',
              overflow: 'hidden',
            }}
          >
            {/* Header: title and amount */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 3,
                pt: 2,
                pb: 1,
              }}
            >
              <Typography variant="h6" sx={{fontWeight: 600}}>
                {exp.title}
              </Typography>
              <Typography variant="h6" sx={{fontWeight: 700}}>
                <Translate expression='caregiver.CaregiverDetail.Payment.Expense.Amount' substitute={{expenses: exp.price}}/>
              </Typography>
            </Box>

            {/* Images row */}
            {
              exp.pictures && exp.pictures.length > 0 && (
                <Box
                  sx={{
                    px: 3,
                    pb: 2,
                  }}
                >
                  <SecureImageDisplay
                    images={exp.pictures.map((src) => ({src}))}
                    sx={{marginTop: 1}}
                  />
                </Box>
              )
            }
          </Box>
        ))
      }
    </Stack>
  );
};

SlipexpenseDetails.propTypes = {
  expenses: PropTypes.array.isRequired,
};

export default SlipexpenseDetails;
